import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../../../../../../components/global/Button';
import SeparatedPinField from '../../../../../../components/global/PinField/SeparatedPinField';
import CustomControl from '../../../../../../components/global/CustomControl';
import { EVENTS } from '../../../../../../services/gtag/constants';
import useGtagManualTracking from '../../../../../../services/gtag/useGtagManualTracking';

const propTypes = {
  className: PropTypes.string,
  loading: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  values: PropTypes.shape({
    phone_number: PropTypes.string.isRequired,
  }).isRequired,
  onPinCodeResend: PropTypes.func.isRequired,
  onEmailSignup: PropTypes.func.isRequired,
  requireHumanInput: PropTypes.bool,
  blockLogin: PropTypes.bool,
};

const EMAIL_PROMPT_DELAY = 20000;

const ShutterbugPhoneVerify = ({
  className,
  loading,
  handleSubmit,
  handleChange,
  errors,
  onPinCodeResend,
  onEmailSignup,
  values,
  requireHumanInput,
  blockLogin,
}) => {
  const { onTrackEvent } = useGtagManualTracking();
  const [showEmailSignupPrompt, setShowEmailSignupPrompt] = useState(false);

  useEffect(() => {
    const t = setTimeout(
      () => setShowEmailSignupPrompt(true),
      EMAIL_PROMPT_DELAY,
    );
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    handleChange({
      target: {
        name: 'force_allow_action',
        value: false,
      },
    });
  }, []);

  useEffect(() => {
    if (values.code?.length === 4) {
      onTrackEvent({
        event: EVENTS.CLICK_VERIFY_PIN_CODE,
        data: { page_title: 'Complete Consumer Pin Auth' },
      });
      handleSubmit();
    }
  }, [values.code]);

  const classes = classNames({
    [className]: !!className,
  });

  return (
    <div className={classes}>
      <form onSubmit={handleSubmit}>
        <p className="registration-pin-heading">Enter your verification PIN</p>

        {errors?.code && (
          <p className="registration-pin-error">{errors.code}</p>
        )}

        <div className="mb-3">
          <SeparatedPinField
            onChange={value => {
              handleChange({
                target: {
                  name: 'code',
                  value,
                },
              });
            }}
          />
        </div>

        {requireHumanInput && (
          <div className="mt-2">
            <CustomControl
              type="checkbox"
              label="I'm not a robot"
              checked={values.force_allow_action}
              onChange={() =>
                handleChange({
                  target: {
                    name: 'force_allow_action',
                    value: !values.force_allow_action,
                  },
                })
              }
            />
          </div>
        )}

        <div className="text-center mt-3 text-sm">
          Didn&apos;t receive the code?{' '}
          <Button
            type="button"
            btnStyle="link"
            btnSize="sm"
            disabled={
              loading ||
              blockLogin ||
              (requireHumanInput && !values.force_allow_action)
            }
            onClick={() => onPinCodeResend(values)}
          >
            Resend code
          </Button>
        </div>
        {showEmailSignupPrompt && (
          <div className="text-center text-sm">
            Not receiving the SMS?{' '}
            <Button btnStyle="link" btnSize="sm" onClick={onEmailSignup}>
              Authenticate with email
            </Button>
          </div>
        )}
      </form>
    </div>
  );
};

ShutterbugPhoneVerify.propTypes = propTypes;

export default ShutterbugPhoneVerify;
